import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { selectBnum } from '../services/webRTCService';
import styled from '@emotion/styled';

const HeaderPanel = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 353px;
    padding: 9px 14px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: rgb(249 250 251 / 1);
    border-bottom: 1px solid rgb(234 236 240 / 1);
    .info {
        display: flex;
        flex-direction: column;
        & > span:nth-of-type(1) {
            color: rgb(21 94 239 / 1);
            font-weight: 600;
            font-size: 0.75rem;
            line-height: 1rem;
        }
        & > span:nth-of-type(2) {
            color: rgb(52 64 84/ 1);
            font-weight: 600;
            font-size: 0.875rem;
            line-height: 1.25rem;
        }
        & > span:nth-of-type(3) {
            color: rgb(71 84 103/ 1);
            font-family: 'Inter', sans-serif;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
        }
    }
    .close-btn {
        cursor: pointer;
        width: 1.25rem;
        height: 1.25rem;
        &:hover {
            background-color: rgba(204, 201, 201, 0.5);
            border-radius: 50%;
        }
        svg {
            color: rgb(102 112 133/ 1);
            width: 20px;
            height: 20px;
        }
    }
`;

const BodyPanel = styled.div`
    margin-top: 85px;
    /* overflow-y: auto;
    max-height: 280px; */
`;

const Line = styled.hr`
    margin: 8px 0;
    height: 0;
    border: unset;
    border-top: 1px solid rgb(234 236 240 / 1);
`;

const BnumsList = styled.div``;

const BnumInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .sectionLeft {
        display: flex;
        flex-direction: column;
        & > span:nth-of-type(1) {
            color: rgb(52 64 84/ 1);
            font-weight: 600;
            font-size: 0.875rem;
            line-height: 1.25rem;
        }
        & > span:nth-of-type(2) {
            color: rgb(71 84 103/ 1);
            font-family: 'Inter', sans-serif;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
        }
    }
    .sectionRight {
        background-color: rgb(242 244 247/ 1);
        border-radius: 1rem;
        span {
            padding: 2px 8px;
            color: rgb(52 64 84/ 1);
            font-weight: 500;
            font-size: 0.75rem;
            line-height: 1rem;
        }
    }
`;

const NotFoundMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;
    color: #607179;

    svg {
        width: 64px;
        height: 64px;
        margin-bottom: 1rem;
    }

    h2 {
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
    }

    p {
        font-size: 1rem;
    }
`;

const Bnums = ({
    setBnumsVisible,
    setSelectedBnum,
    selectedBnum,
    bnumsList,
    auth,
    statusCode,
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBnums, setFilteredBnums] = useState([]);

    // const FakeBnums = [
    //     { number: "+61420102083", username: "60008897", password: "YgEtPb1f" },
    //     { number: "+61488822740", username: "60006024", password: "Dy5Lpze" },
    // ];

    useEffect(() => {
        if (searchTerm.length > 0) {
            const filtered = bnumsList.filter((bnum) =>
                bnum.bnum.includes(searchTerm.toLowerCase())
            );
            setFilteredBnums(filtered);
        } else {
            setFilteredBnums(bnumsList);
        }
    }, [searchTerm]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSelectBnum = async (mybnum) => {
        try {
            const data = await selectBnum(mybnum.bnum, auth, false);
            console.log('API response:', data);
            console.log('mybnum', mybnum);
            const country = mybnum.bnum.includes('+60') ? 'my' : 'au';
            const tempBnum = {
                ...mybnum,
                country: country,
                client_id: mybnum.extension.substring(0, 4),
            };
            // Proceed with setting the selected bnum and closing the panel
            setSelectedBnum(tempBnum);
            setBnumsVisible(false);
        } catch (error) {
            console.error('Error calling API:', error);
            // You might want to show an error message to the user here
        }
    };

    return (
        <div>
            <HeaderPanel>
                <div className="info">
                    <span>SELECTED</span>
                    <span>{selectedBnum?.bnum}</span>
                    <span>
                        {selectedBnum?.bnum} (
                        {selectedBnum?.adName
                            ? selectedBnum.adName
                            : 'User not assigned'}
                        )
                    </span>
                </div>
                <div
                    className="close-btn"
                    onClick={() => setBnumsVisible(false)}
                >
                    <svg
                        data-v-8dfce144=""
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        aria-hidden="true"
                        className="h-5 w-5 text-gray-500"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M17 7L7 17M7 7l10 10"
                        ></path>
                    </svg>
                </div>
            </HeaderPanel>
            <BodyPanel>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search Numbers"
                    size="small"
                    style={{ marginBottom: '5px' }}
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                    style={{ width: '1rem', height: '1rem' }}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M21 21l-3.5-3.5m2.5-6a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
                                    />
                                </svg>
                            </InputAdornment>
                        ),
                    }}
                />
                <Line />
                <BnumsList>
                    {filteredBnums.length > 0 ? (
                        filteredBnums.map((bnum) => (
                            <React.Fragment key={bnum.bnum}>
                                <BnumInfo
                                    onClick={() => handleSelectBnum(bnum)}
                                >
                                    <div className="sectionLeft">
                                        <span>{bnum.bnum}</span>
                                        <span>
                                            {bnum.bnum} ({bnum.adName})
                                        </span>
                                    </div>
                                    {/* <div className="sectionRight"><span>Local</span></div> */}
                                </BnumInfo>
                                <Line />
                            </React.Fragment>
                        ))
                    ) : (
                        <NotFoundMessage>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            {(() => {
                                switch (statusCode) {
                                    case 204:
                                        return (
                                            <>
                                                <h2>No tracking numbers</h2>
                                                <p>
                                                    No tracking numbers
                                                    provisioned to your user.
                                                    Kindly contact support at
                                                    support@avanser.com.au to
                                                    assist you!
                                                </p>
                                            </>
                                        );
                                    case 403:
                                        return (
                                            <>
                                                <h2>Permission denied</h2>
                                                <p>
                                                    you don't have the necessary
                                                    permissions to access.
                                                    Kindly contact support at
                                                    support@avanser.com.au to
                                                    assist you!
                                                </p>
                                            </>
                                        );
                                    case 200:
                                        return (
                                            <>
                                                <h2>Number Not Found</h2>
                                                <p>
                                                    We couldn't find any number
                                                    matching your search.
                                                </p>
                                            </>
                                        );
                                    default:
                                        return (
                                            <>
                                                <h2>Unknown Error!</h2>
                                                <p>
                                                    For fixing this issue kindly
                                                    contact support at
                                                    support@avanser.com.au to
                                                    assist you!
                                                </p>
                                            </>
                                        );
                                }
                            })()}
                        </NotFoundMessage>
                    )}
                </BnumsList>
            </BodyPanel>
        </div>
    );
};

export default Bnums;
